// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".curso-selecionado{font-size:1.1rem!important}.curso-name{transition:font-size .2s}.titulo-cursos{background:#004d96;border-radius:6px;color:#fff!important;margin-bottom:25px;padding:10px}.separator{border-bottom:2px dotted #b9b9b9;flex:1 1 auto;margin:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
